export interface ProgressSubscriber {
  (progress: number | undefined): void;
}

export class Progress {
  subscriber: ProgressSubscriber | undefined;

  started = false;
  completed = 0;
  total = 0;

  constructor(subscriber?: ProgressSubscriber) {
    this.subscriber = subscriber;
  }

  bump(bumpCompleted = 0, totalBump = 0) {
    this.started = true;
    const before = this.current();
    this.total = this.total + totalBump;
    this.completed = this.completed + bumpCompleted;
    const current = this.current();
    if (this.subscriber && before && current && current > before)
      this.subscriber(current);
  }

  reset() {
    this.started = false;
    if (this.subscriber) this.subscriber(this.current());
  }

  current() {
    if (!this.started) return undefined;
    if (this.completed === 0 || this.total === 0) return 0;
    return Math.floor((this.completed / this.total) * 100);
  }
}
